import { Widget, WidgetProps } from "@rjsf/utils";
import React from "react";

export const UnlimitedCheckboxWidget: Widget = (props: WidgetProps) => {
  return (
    <div className={"form-check"}>
      <label className={"control-label"}>
        <input
          className={"unlimited-checkbox"}
          type="checkbox"
          checked={props.value ?? false}
          required={props.required}
          onChange={(event) => props.onChange(event.currentTarget.checked)}
        />
        <span>
          <span style={{ display: "inline-block", marginLeft: 5 }} className={"limited-checkbox-label"}>
            {props.label}
          </span>
        </span>
      </label>
    </div>
  );
};
